import { faDoorOpen } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Modal } from "react-bootstrap"

interface Props {
    showModal: boolean
    onHide: () => void
}

const LoggedOutModal = ({ showModal, onHide } : Props) => {
    const navigateLogIn = () => window.open(`${window.location.origin}/account/log-in`, "_blank")

  return (
    <Modal show={showModal} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title className="w-100"><FontAwesomeIcon icon={faDoorOpen} /> You have been logged out.</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>You have been logged out due to inactivity. Please log in again.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Stay Logged Out
        </Button>
        <Button variant="primary" onClick={navigateLogIn}>
          Log In
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default LoggedOutModal
